<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <router-link :to="{name: 'Add Gallery'}">
                    <el-button type="primary" class="fluid">{{ $t('add') }} Galerię <i class="el-icon-plus"></i>
                    </el-button>
                </router-link>
                <ListFilterComponent @setFilter="setFilter"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="70"></el-table-column>
                    <el-table-column label="nazwa (pl)" prop="name_pl"/>
                    <el-table-column label="edycja">
                        <template slot-scope="scope">
                            {{ getEditionLabel(scope.row.edition) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="podgląd" width="340">
                        <template slot-scope="scope">
                            <img class="thumbnail"
                                 :src="image.thumbnail"
                                 :alt="image.alt_pl"
                                 v-for="image in scope.row.images.slice(0, 3)">
                        </template>
                    </el-table-column>
                    <el-table-column label="opcje" width="150" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <router-link :to="{name: 'Edit Gallery', params: {id: scope.row.id}}">
                                <el-button size="small" :title="$t('edit')">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </router-link>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="handleDelete(scope.$index, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="24" class="list__pagination">
                <el-pagination layout="prev, pager, next"
                               @current-change="handlePageChange"
                               :page-size="pageSize" :total="count">
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {Folder} from '@/api';
    import ListFilterComponent from '@/components/ListFilterComponent'

    export default {
        data () {
            return {
                filters: {
                    available: [
                        {
                            name: 'Edycja',
                            query_param: 'edition',
                            options: []
                        }
                    ],
                    selected: {}
                },
                data: [],
                listLoading: false,
                service: Folder,
                pageSize: 10,
                count: 0,
                page: 1,
                duringEditing: {}
            }
        },
        methods: {
            photoDuringEdition (photo) {
                return this.duringEditing[photo.id] !== undefined
            },
            handlePageChange (val) {
                this.page = val;
                this.fetchData();
            },
            setFilter (filter) {
                this.page = 1
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            getEditionLabel (id) {
                const compareId = edition => edition.id === id
                const edition = this.$store.state.editions.find(compareId)
                return edition && edition.year
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                this.listLoading = true;
                this.service.fetch({}, {params}).then(response => {
                    this.count = response.data.count;
                    this.pageSize = response.data.page_size;
                    this.data = response.data.results;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                await this.service.delete(row.id)

                this.listLoading = false;
                this.$message({
                    message: 'Element został usunięty',
                    type: 'success'
                })

                this.fetchData()
            }
        },
        mounted () {
            this.fetchData();
            this.$store.dispatch('fetchEditions')
        },
        components: {
            ListFilterComponent
        },
        watch: {
            '$store.state.editions' (value) {
                let options = value.map(edition => {
                    return {label: edition.year, value: edition.id, defaultSelected: edition.current}
                })
                options = [
                    {label: 'Wszystkie', value: ''},
                    ...options
                ]
                const defaultFilter = options.find(option => option.defaultSelected)
                this.$set(this.filters.available[0], 'options', options)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .thumbnail {
        display: inline-block;
        max-width: 100px;
        margin: 1px;
    }
</style>



// WEBPACK FOOTER //
// GalleriesList.vue?53df06f4